/* @ngInject */
function productsFrameService (ConnectorWebService, Upload, Utils, CONSTANTS, $translate) {
  const service = {
    getProducts,
    importProducts,
    deleteProducts,
    updateProduct,
    updateAssetProduct,
    getImportErrorText,
    hasFeature
  }

  return service

  function getProducts (params) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_FRAME)

    const {
      search = '',
      top = 10,
      skip = 0,
      $sort = '',
      $order = 'DESC'
    } = params

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if ($sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort })
    }
    if ($order) {
      url = Utils.fnAddQueryToUrl(url, { $order })
    }

    return ConnectorWebService.get(url)
  }

  function importProducts (mode, payload) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_FRAME)

    if (mode) {
      url = Utils.fnAddQueryToUrl(url, { mode })
    }

    return Upload.upload({
      url,
      data: payload
    })
  }

  function deleteProducts (payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_FRAME_DELETE)
    return ConnectorWebService.put(url, payload)
  }

  function updateProduct (productId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_FRAME_ID, [productId])
    return ConnectorWebService.put(url, payload)
  }

  function updateAssetProduct (productId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_FRAME_ID_ASSET, [productId])
    return ConnectorWebService.put(url, payload)
  }

  function getImportErrorText (errorCode) {
    const errors = [
      'FILE_REQUIRED',
      'ONLY_ONE_FILE_ALLOWED',
      'UNSUPPORTED_FORMAT',
      'IMPORT_ERROR',
      'MAX_LINES_EXCEEDED',
      'EMPTY_FILE',
      'NO_DATA_ROWS',
      'INVALID_HEADERS',
      'INVALID_HEADER_ORDER',
      'DUPLICATED_EXTERNAL_IDS',
      'MISSING_EXTERNAL_ID',
      'MISSING_PRODUCT_NAME'
    ]

    const isMappedError = errors.some(error => error === errorCode)

    if (errorCode && isMappedError) {
      return $translate.instant(`productFrame.addProductModal.errors.${errorCode}`)
    }

    return null
  }

  function hasFeature () {
    return true
  }
}

export { productsFrameService }
